export function getProductArchiveFilterIndicatorComponent(idBase) {
    return {
        name: 'ProductArchiveFilterIndicator',
        props: {
            settings: {
                type: Object,
                required: true,
            },
        },
        computed: {
            showOnlyInStock() {
                return this.settings.showOnlyInStock;
            },
            showOnlyForwardingGoods() {
                return this.settings.showOnlyForwardingGoods;
            },
            hideBundles() {
                return this.settings.hideBundles;
            },
            filterBy() {
                const filterBy = [];

                for (const filterAttribute in this.settings.filterBy) {
                    if (
                        Object.prototype.hasOwnProperty.call(this.settings.filterBy, filterAttribute) &&
                        this.settings.filterBy[filterAttribute]
                    ) {
                        const value = this.settings.filterBy[filterAttribute];

                        if (typeof value === 'string') {
                            filterBy.push({
                                name: filterAttribute,
                                value,
                                text: this.settings.filterAttributes
                                    .find((attr) => attr.name === filterAttribute)
                                    .values.find((v) => v.value === value).text,
                            });
                        } else if (Array.isArray(value)) {
                            for (const val of value) {
                                filterBy.push({
                                    name: filterAttribute,
                                    value: val,
                                    text: this.settings.filterAttributes
                                        .find((attr) => attr.name === filterAttribute)
                                        .values.find((v) => v.value === val).text,
                                });
                            }
                        }
                    }
                }

                return filterBy;
            },
            numberOfSetFilters() {
                let ct = 0;

                if (this.showOnlyInStock) {
                    ct++;
                }

                if (this.showOnlyForwardingGoods) {
                    ct++;
                }

                if (this.hideBundles) {
                    ct++;
                }

                return ct + this.filterBy.length;
            },
        },
        methods: {
            onDeleteClick(setting, type, value = '') {
                this.$emit('delete', [{ setting, type, value }]);
            },
            onDeleteAllClick() {
                this.$emit('delete', [
                    {
                        setting: 'showOnlyInStock',
                        type: 'checkbox',
                    },
                    {
                        setting: 'showOnlyForwardingGoods',
                        type: 'checkbox',
                    },
                    {
                        setting: 'hideBundles',
                        type: 'checkbox',
                    },
                    ...this.filterBy.map(({ name, value }) => {
                        return { setting: name, type: 'checkboxes', value };
                    }),
                ]);
            },
        },
        template: `#${idBase}-filter-indicator`,
    };
}
